/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NotificationEmail
 */
export interface NotificationEmail {
    /**
     * 
     * @type {string}
     * @memberof NotificationEmail
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationEmail
     */
    email: string;
}

/**
 * Check if a given object implements the NotificationEmail interface.
 */
export function instanceOfNotificationEmail(value: object): value is NotificationEmail {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function NotificationEmailFromJSON(json: any): NotificationEmail {
    return NotificationEmailFromJSONTyped(json, false);
}

export function NotificationEmailFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationEmail {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'email': json['email'],
    };
}

export function NotificationEmailToJSON(json: any): NotificationEmail {
    return NotificationEmailToJSONTyped(json, false);
}

export function NotificationEmailToJSONTyped(value?: NotificationEmail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'email': value['email'],
    };
}

